import { testimonials } from "../data/content"

export function GoTestimonialsSection() {
  return (
    <div className="mk-section">
      <div className="mk-container mk-text-center" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <span className="mk-chip">
          <span className="mk-chip-icon">
            <img src="/marketing/go/icons/message.svg" alt="" />
          </span>
          Testimonials
        </span>

        <h2 className="mk-title">
          What Our <span className="mk-title-accent">Users Say</span>
        </h2>

        <div className="mk-testimonials">
          {testimonials.map((t) => (
            <div key={t.name} className="mk-testimonial">
              <div style={{ display: "flex", flexDirection: "column", gap: 16, flexGrow: 1 }}>
                <div className="stars">{"★".repeat(t.stars)}</div>
                <h4>{t.title}</h4>
                <p className="quote">{t.description}</p>
              </div>
              <div className="author">
                <img src={t.image} alt={t.name} />
                <div>
                  <div className="author-name">{t.name}</div>
                  <div className="author-role">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
